export default __webpack_public_path__ + "static/media/Ies_NombreSeminarioREGISTRO.27c5ea24.png";